import { useState } from "react";
import axios from "axios";
import { Lock, AlertCircle, CheckCircle2 } from "lucide-react";
import { useAuth, formatApiError } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPasswordPage({ token }) {
  const { setSessionFromReset } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const clearTokenFromUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("reset_token");
    window.history.replaceState({}, "", url.pathname + (url.search || ""));
  };

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("Şifre en az 6 karakter olmalı");
      return;
    }
    if (password !== confirm) {
      setError("Şifreler eşleşmiyor");
      return;
    }
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/auth/reset-password`, { token, password });
      // Save session then hard-navigate to root (drops the ?reset_token query param)
      setSessionFromReset(data.token, data.user);
      setDone(true);
      setTimeout(() => {
        window.location.assign("/");
      }, 1200);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message || "Sıfırlama başarısız");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card" data-testid="reset-card">
        <div className="auth-brand">
          <div className="brand-mark brand-logo" data-testid="brand-logo"><img src="/brand/logo-mark.png" alt="Sigorta CRM" /></div>
          <div>
            <strong>Sigorta<span>Crm</span></strong>
            <small>BİREYSEL SİGORTA TAKİP PANELİ</small>
          </div>
        </div>
        <div className="auth-title">
          <h1>Yeni şifre belirleyin</h1>
          <p>Şifrenizi güncelledikten sonra otomatik giriş yapılır.</p>
        </div>
        {done ? (
          <div className="auth-sent" data-testid="reset-done">
            <CheckCircle2 size={44} />
            <p>Şifreniz güncellendi. Yönlendiriliyorsunuz…</p>
          </div>
        ) : (
          <form onSubmit={submit} className="auth-form">
            <label className="auth-field">
              <span>Yeni şifre</span>
              <div className="auth-input"><Lock size={16} /><input data-testid="reset-password-input" type="password" placeholder="En az 6 karakter" value={password} onChange={(e) => setPassword(e.target.value)} required autoFocus /></div>
            </label>
            <label className="auth-field">
              <span>Yeni şifre (tekrar)</span>
              <div className="auth-input"><Lock size={16} /><input data-testid="reset-confirm-input" type="password" placeholder="Şifreyi tekrar yazın" value={confirm} onChange={(e) => setConfirm(e.target.value)} required /></div>
            </label>
            {error && <div className="auth-error" data-testid="reset-error"><AlertCircle size={15} />{error}</div>}
            <button className="primary-button auth-submit" data-testid="reset-submit" disabled={busy}>{busy ? "İşleniyor…" : "Şifreyi güncelle"}</button>
          </form>
        )}
      </div>
      <div className="auth-side" aria-hidden="true">
        <div className="auth-side-quote">
          <em>"Yeni şifreniz sadece bir tık uzaklıkta."</em>
          <span>— SigortaCrm</span>
        </div>
      </div>
    </div>
  );
}
